import type { ReactNode } from 'react';
import { Chip, Stack } from '@mui/material';
import { isValid, format, subDays } from 'date-fns';

export const MissionDateChip = ({
    date,
}: {
    date: string | null | undefined;
}) => {
    const wrap = (chip: ReactNode) => (
        <Stack direction="row" alignItems="center" component="span">
            {chip}
        </Stack>
    );

    if (!date)
        return wrap(<Chip label="No date" size="small" color="default" />);

    const d = new Date(date);
    const now = new Date();

    if (!isValid(d))
        return wrap(<Chip label="Invalid date" size="small" color="error" />);

    let color: 'default' | 'error' | 'warning' | 'primary' = 'default';
    if (now <= d) {
        if (now > subDays(d, 3)) color = 'error';
        else if (now > subDays(d, 7)) color = 'warning';
        else if (now > subDays(d, 14)) color = 'primary';
    }

    return wrap(<Chip label={format(d, 'PPpp')} size="small" color={color} />);
};
